// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3pUui","item":"PaymentsMobile_item__1-pdQ","label":"PaymentsMobile_label__zWjpm","amount":"PaymentsMobile_amount__9pBA2"};